import { render } from "./AddNewPartnerDocument.vue?vue&type=template&id=394a2f20&scoped=true"
import script from "./AddNewPartnerDocument.vue?vue&type=script&lang=js"
export * from "./AddNewPartnerDocument.vue?vue&type=script&lang=js"

import "./AddNewPartnerDocument.vue?vue&type=style&index=0&id=394a2f20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394a2f20"]])

export default __exports__